import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";

import lazyload from "./features/lazy-load";
import proportionalScroll from "./features/proportional-scroll";

lazyload();
proportionalScroll();

initMain([], {
  SectionPager: () => import("./vue/components/section-pager/SectionPager.vue"),
  MiniQuoteGraph: () =>
    import("./vue/components/mini-quote-graph/MiniQuoteGraph.vue"),
  TrendsHorizontal: () =>
    import("./vue/components/trends/TrendsHorizontal.vue"),
});
header();
